import { Component, Input } from '@angular/core';

@Component({
  selector: 'evrideo-skip-forward-icon',
  templateUrl: './skip-forward-icon.component.html',
  styleUrls: ['./skip-forward-icon.component.scss'],
})
export class SkipForwardIconComponent {
  @Input()
  overrideStyle: Record<string, string> = {};
}
